import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const GoHighLevelWhite = forwardRef<SVGSVGElement, IconProps>(({ size = 20 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 39 36"
      fill="none"
      ref={forwardedRef}
    >
      <g filter="url(#a)">
        <path fill="#FEC401" d="M10.198 11.899h2.814v16.238h-2.814z" />
        <path fill="#4ACF28" d="M22.421 11.899h2.814v16.238h-2.814z" />
        <path fill="#2996FB" d="M16.09 18.671h3.107v9.467H16.09z" />
        <path fill="#FEC401" d="M16.177 11.929H7.12l4.514-4.778 4.543 4.778Z" />
        <path fill="#2996FB" d="M22.348 18.67h-9.233l4.602-4.87 4.63 4.87Z" />
        <path fill="#4ACF28" d="M28.4 11.929h-9.057l4.514-4.778L28.4 11.93Z" />
        <path fill="#52B447" d="m25.242 14.67-2.822-2.74h2.822v2.74Z" />
        <path fill="#1F81DC" d="m19.199 21.773-3.103-3.093H19.2v3.093Z" />
        <path fill="#DAAA00" d="m13.019 14.67-2.821-2.74h2.82v2.74Z" />
      </g>
      <defs>
        <filter
          id="a"
          width="46"
          height="46"
          x="-5"
          y="-3"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_5481_113206" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_5481_113206" result="shape" />
        </filter>
      </defs>
    </svg>
  )
})
